import { FEEDBACK_SAGA_GET_DATA } from '../actionTypes'

export const getFeedback = date => ({ date, type: FEEDBACK_SAGA_GET_DATA })
